import { render, staticRenderFns } from "./Cause.vue?vue&type=template&id=49d9f25d&scoped=true&"
import script from "./Cause.vue?vue&type=script&lang=js&"
export * from "./Cause.vue?vue&type=script&lang=js&"
import style0 from "./Cause.vue?vue&type=style&index=0&id=49d9f25d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d9f25d",
  null
  
)

export default component.exports